import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import StarshipChapter from './StarshipChapter.vue';
import StarshipsModifications from '@/pages/Starships/StarshipsModifications.vue';
let StarshipModifications = class StarshipModifications extends Vue {
};
StarshipModifications = __decorate([
    Component({
        components: {
            StarshipChapter,
            StarshipsModifications
        }
    })
], StarshipModifications);
export default StarshipModifications;
